import React from "react";
import Button from "@material-ui/core/Button";
import { useSelector } from "react-redux";

export default function OutOfStock({ type_of_product }) {
  const language = useSelector((state) => state.store.language);
  const customTexts = useSelector(
    (state) => state.store.store.settings.custom_texts
  );

  const text =
    type_of_product === "bookable"
      ? (language === "arabic" && customTexts.fully_booked_ar) ||
        customTexts.fully_booked
      : (language === "arabic" && customTexts.out_of_stock_ar) ||
        customTexts.out_of_stock;
  return (
    <Button
      className="mx-auto"
      variant="outlined"
      disableRipple
      disableElevation
      size={"small"}
      style={{
        color: "#e4a3a3",
        fontWeight: "bold",
        border: "1px solid",
        direction: language === "arabic" && "ltr",
        textTransform: "none",
        fontSize: 14,
        height: 30,
      }}
    >
      <span>{text}</span>
    </Button>
  );
}
